module.exports = __webpack_public_path__ + "static/emision2-04a96726f1bb23bc8c16a751b2e50656.jpg";